const LOCALE_KEYS = ["pl", "en", "de", "es", "fr", "it", "sk", "uk"];

const TOPICS = {
  vmix: {
    pl: "vMix i SRT dla produkcji w chmurze",
    en: "vMix and SRT for cloud production",
    de: "vMix und SRT für die Cloud-Produktion",
    es: "vMix y SRT para producción en la nube",
    fr: "vMix et SRT pour la production cloud",
    it: "vMix e SRT per la produzione cloud",
    sk: "vMix a SRT pre cloudovú produkciu",
    uk: "vMix і SRT для хмарного виробництва",
  },
  obs: {
    pl: "OBS, Browser Source i emisja live",
    en: "OBS, Browser Source, and live delivery",
    de: "OBS, Browser Source und Live-Ausspielung",
    es: "OBS, Browser Source y distribución en directo",
    fr: "OBS, Browser Source et diffusion en direct",
    it: "OBS, Browser Source e distribuzione live",
    sk: "OBS, Browser Source a živé vysielanie",
    uk: "OBS, Browser Source і пряма трансляція",
  },
  blackmagic: {
    pl: "Blackmagic ATEM i zdalna dystrybucja",
    en: "Blackmagic ATEM and remote distribution",
    de: "Blackmagic ATEM und Remote-Distribution",
    es: "Blackmagic ATEM y distribución remota",
    fr: "Blackmagic ATEM et distribution à distance",
    it: "Blackmagic ATEM e distribuzione remota",
    sk: "Blackmagic ATEM a vzdialená distribúcia",
    uk: "Blackmagic ATEM і віддалена дистрибуція",
  },
  companion: {
    pl: "Bitfocus Companion i sterowanie Stream Deck",
    en: "Bitfocus Companion and Stream Deck control",
    de: "Bitfocus Companion und Stream-Deck-Steuerung",
    es: "Bitfocus Companion y control con Stream Deck",
    fr: "Bitfocus Companion et contrôle Stream Deck",
    it: "Bitfocus Companion e controllo Stream Deck",
    sk: "Bitfocus Companion a ovládanie Stream Deck",
    uk: "Bitfocus Companion і керування Stream Deck",
  },
};

const PAGE_LABELS = {
  pl: {
    back: "Wszystkie integracje",
    external: "Strona partnera",
    architecture: "Jak działa integracja",
    architectureLead:
      "Zobacz, jak funkcje partnera przekładają się na konkretne możliwości w Twojej pracy z MediaDock.",
    implementation: "Co zyskujesz jako klient",
    implementationLead:
      "Najważniejsze możliwości dostępne dzięki połączeniu MediaDock z tym partnerem.",
    faq: "Najczęstsze pytania",
    related: "Poznaj pozostałe integracje",
    relatedLead:
      "Wybierz kolejny element ekosystemu i sprawdź, jak może uzupełnić ten workflow.",
    resources: "Powiązane usługi i kolejne kroki",
    resourcesLead:
      "Integracja jest częścią większego środowiska MediaDock. Przejdź do usługi, konfiguracji lub rejestracji odpowiedniej dla Twojego zespołu.",
    contact: "Potrzebujesz niestandardowego połączenia?",
    contactLead:
      "Opisz swój sprzęt, protokół i cel produkcji. Pomożemy dobrać bezpieczny kontrakt integracyjny.",
    contactCta: "Porozmawiaj z zespołem",
  },
  en: {
    back: "All integrations",
    external: "Partner website",
    architecture: "How the integration works",
    architectureLead:
      "See how the partner’s capabilities become practical options in your MediaDock workflow.",
    implementation: "What you gain as a customer",
    implementationLead:
      "The key capabilities available through the MediaDock partnership.",
    faq: "Frequently asked questions",
    related: "Explore other integrations",
    relatedLead:
      "Choose another part of the ecosystem and see how it can extend this workflow.",
    resources: "Related services and next steps",
    resourcesLead:
      "An integration is part of a wider MediaDock environment. Open the service, configuration, or registration flow that fits your team.",
    contact: "Need a custom connection?",
    contactLead:
      "Tell us about your equipment, protocol, and production goal. We will help define a safe integration contract.",
    contactCta: "Talk to the team",
  },
  de: {
    back: "Alle Integrationen",
    external: "Partner-Website",
    architecture: "So funktioniert die Integration",
    architectureLead:
      "Sehen Sie, wie die Funktionen des Partners praktische Möglichkeiten in MediaDock schaffen.",
    implementation: "Ihr Kundenvorteil",
    implementationLead:
      "Die wichtigsten Möglichkeiten aus der Partnerschaft mit MediaDock.",
    faq: "Häufige Fragen",
    related: "Weitere Integrationen",
    relatedLead:
      "Wählen Sie einen weiteren Teil des Ökosystems und sehen Sie, wie er diesen Workflow ergänzt.",
    resources: "Verwandte Services und nächste Schritte",
    resourcesLead:
      "Eine Integration ist Teil der MediaDock-Umgebung. Öffnen Sie den passenden Service, die Konfiguration oder die Registrierung.",
    contact: "Benötigen Sie eine individuelle Verbindung?",
    contactLead:
      "Beschreiben Sie Hardware, Protokoll und Produktionsziel. Wir helfen bei einem sicheren Integrationsvertrag.",
    contactCta: "Mit dem Team sprechen",
  },
  es: {
    back: "Todas las integraciones",
    external: "Sitio del partner",
    architecture: "Cómo funciona la integración",
    architectureLead:
      "Descubre cómo las funciones del partner se convierten en posibilidades prácticas dentro de MediaDock.",
    implementation: "Qué obtienes como cliente",
    implementationLead:
      "Las principales posibilidades disponibles gracias a la colaboración con MediaDock.",
    faq: "Preguntas frecuentes",
    related: "Explora otras integraciones",
    relatedLead:
      "Elige otra parte del ecosistema y descubre cómo puede ampliar este flujo de trabajo.",
    resources: "Servicios relacionados y próximos pasos",
    resourcesLead:
      "La integración forma parte del entorno MediaDock. Abre el servicio, la configuración o el registro adecuado para tu equipo.",
    contact: "¿Necesitas una conexión personalizada?",
    contactLead:
      "Cuéntanos tu equipo, protocolo y objetivo de producción. Te ayudaremos a definir una integración segura.",
    contactCta: "Hablar con el equipo",
  },
  fr: {
    back: "Toutes les intégrations",
    external: "Site du partenaire",
    architecture: "Comment fonctionne l’intégration",
    architectureLead:
      "Découvrez comment les fonctions du partenaire deviennent des possibilités concrètes dans MediaDock.",
    implementation: "Vos bénéfices client",
    implementationLead:
      "Les principales possibilités offertes par ce partenariat avec MediaDock.",
    faq: "Questions fréquentes",
    related: "Découvrir les autres intégrations",
    relatedLead:
      "Choisissez un autre élément de l’écosystème et voyez comment il complète ce workflow.",
    resources: "Services associés et prochaines étapes",
    resourcesLead:
      "L’intégration fait partie de l’environnement MediaDock. Ouvrez le service, la configuration ou l’inscription adaptée à votre équipe.",
    contact: "Besoin d’une connexion personnalisée ?",
    contactLead:
      "Décrivez votre matériel, votre protocole et votre objectif de production. Nous vous aiderons à définir une intégration sûre.",
    contactCta: "Parler à l’équipe",
  },
  it: {
    back: "Tutte le integrazioni",
    external: "Sito del partner",
    architecture: "Come funziona l’integrazione",
    architectureLead:
      "Scopri come le funzioni del partner diventano possibilità concrete nel tuo workflow MediaDock.",
    implementation: "Cosa ottieni come cliente",
    implementationLead:
      "Le principali possibilità disponibili grazie alla partnership con MediaDock.",
    faq: "Domande frequenti",
    related: "Scopri le altre integrazioni",
    relatedLead:
      "Scegli un altro elemento dell’ecosistema e scopri come può completare questo workflow.",
    resources: "Servizi collegati e prossimi passi",
    resourcesLead:
      "L’integrazione fa parte dell’ambiente MediaDock. Apri il servizio, la configurazione o la registrazione adatta al tuo team.",
    contact: "Ti serve una connessione personalizzata?",
    contactLead:
      "Descrivi hardware, protocollo e obiettivo della produzione. Ti aiuteremo a definire un’integrazione sicura.",
    contactCta: "Parla con il team",
  },
  sk: {
    back: "Všetky integrácie",
    external: "Web partnera",
    architecture: "Ako integrácia funguje",
    architectureLead:
      "Pozrite sa, ako sa funkcie partnera premietajú do praktických možností v MediaDock.",
    implementation: "Čo získate ako zákazník",
    implementationLead:
      "Najdôležitejšie možnosti dostupné vďaka partnerstvu s MediaDock.",
    faq: "Časté otázky",
    related: "Ďalšie integrácie",
    relatedLead:
      "Vyberte ďalšiu časť ekosystému a zistite, ako môže rozšíriť tento workflow.",
    resources: "Súvisiace služby a ďalšie kroky",
    resourcesLead:
      "Integrácia je súčasťou prostredia MediaDock. Otvorte vhodnú službu, konfiguráciu alebo registráciu.",
    contact: "Potrebujete vlastné prepojenie?",
    contactLead:
      "Opíšte hardvér, protokol a cieľ produkcie. Pomôžeme definovať bezpečný integračný kontrakt.",
    contactCta: "Kontaktovať tím",
  },
  uk: {
    back: "Усі інтеграції",
    external: "Сайт партнера",
    architecture: "Як працює інтеграція",
    architectureLead:
      "Дізнайтеся, як можливості партнера перетворюються на практичні функції у вашому MediaDock.",
    implementation: "Що отримує клієнт",
    implementationLead:
      "Ключові можливості, доступні завдяки партнерству з MediaDock.",
    faq: "Поширені питання",
    related: "Інші інтеграції",
    relatedLead:
      "Оберіть інший елемент екосистеми та дізнайтеся, як він доповнює цей workflow.",
    resources: "Пов’язані сервіси та наступні кроки",
    resourcesLead:
      "Інтеграція є частиною середовища MediaDock. Відкрийте потрібний сервіс, налаштування або реєстрацію.",
    contact: "Потрібне нестандартне підключення?",
    contactLead:
      "Опишіть обладнання, протокол і мету виробництва. Ми допоможемо визначити безпечний контракт інтеграції.",
    contactCta: "Зв’язатися з командою",
  },
};

const FRAME_TEXT = {
  pl: {
    title: (name, topic) => `${topic} — integracja ${name} z MediaDock`,
    lead: (name, topic) =>
      `Połącz ${name} z MediaDock, aby wykorzystać ${topic.toLowerCase()} w kontrolowanym środowisku produkcji live. Zachowaj specjalistyczne narzędzie partnera, a planowanie, transport, wyjścia, monitoring i współpracę zespołu uporządkuj w jednym workflow.`,
    workflowTitle: "Rola integracji w produkcji",
    workflowOne: (name, summary) =>
      `${summary} W praktyce ${name} pozostaje miejscem obsługi swojej specjalistycznej funkcji, natomiast MediaDock dodaje kontekst projektu, wydarzenia, załogi i strumienia. Dzięki temu operator nie musi budować procesu z niezależnych paneli ani przepisywać tych samych danych między systemami.`,
    workflowTwo: (name, topic) =>
      `Scenariusz ${topic.toLowerCase()} można rozpocząć od jednego źródła i jednej produkcji, a następnie rozszerzać o kolejne wyjścia, nagrania, grafiki, komunikację i role. Taki etapowy model ogranicza ryzyko wdrożenia, jednocześnie zostawiając miejsce na automatyzację pracy ${name}.`,
    technicalTitle: "Architektura danych, sygnału i uprawnień",
    technicalOne: (name) =>
      `Przed uruchomieniem opisz wejścia, identyfikator produkcji, format danych, protokół transportowy, wymagane uprawnienia oraz właściciela każdego błędu. Kontrakt między ${name} i MediaDock powinien jasno wskazywać, który system jest źródłem prawdy, kiedy następuje synchronizacja i co dzieje się po utracie połączenia.`,
    technicalTwo: (name) =>
      `Dobrze zaprojektowany workflow rozdziela realizację od dystrybucji. ${name} może dostarczać sygnał, dane lub akcję operatorską, a MediaDock może sterować statusem produkcji, wyjściami, archiwum i dostępem zespołu. To ułatwia audyt, zmianę operatora i późniejsze skalowanie bez zmiany podstawowego narzędzia.`,
    operationsTitle: "Monitoring, fallback i skalowanie",
    operationsOne: (name) =>
      `Testy powinny obejmować normalną emisję, częściową awarię, restart urządzenia, ponowne połączenie i przekazanie produkcji innemu operatorowi. W przypadku ${name} warto wcześniej zdefiniować, czy awaria partnera zatrzymuje cały program, czy uruchamia przygotowane wyjście zapasowe.`,
    operationsTwo: (name) =>
      `Po wdrożeniu zespół powinien widzieć stan ingestu, wyjść, danych i zadań bez otwierania wielu niezależnych narzędzi. MediaDock pozwala połączyć te informacje z harmonogramem, Run of Show, prompterem, interkomem, grafiką i nagraniem, aby produkcja była powtarzalna także przy większej liczbie wydarzeń.`,
    steps: (name, topic) => [
      `Zdefiniuj cel integracji ${name} i wybierz jeden reprezentatywny scenariusz ${topic.toLowerCase()}.`,
      "Ustal źródło prawdy, identyfikatory produkcji, format danych i wymagane uprawnienia.",
      "Skonfiguruj wejście, transport oraz wyjścia MediaDock zgodnie z warunkami sieci i emisji.",
      "Dodaj linki do grafiki, promptera, interkomu, Run of Show lub nagrywania, jeśli są potrzebne.",
      "Przetestuj reconnect, częściową awarię, backup i przekazanie sterowania innemu operatorowi.",
      `Opisz gotowy proces dla zespołu i monitoruj pierwsze transmisje z użyciem ${name}.`,
    ],
    faq: (name) => [
      [
        `Co daje integracja ${name}?`,
        `Łączy specjalistyczne funkcje ${name} z kontekstem produkcji, transportem, wyjściami i monitoringiem MediaDock.`,
      ],
      [
        "Czy można wdrożyć ją etapami?",
        "Tak. Zacznij od jednej produkcji i jednego przepływu, a potem dodawaj role, wyjścia, automatyzacje i kolejne zespoły.",
      ],
      [
        "Co ustalić przed startem?",
        "Zakres danych, uprawnienia, źródło prawdy, zachowanie po awarii, monitoring oraz procedurę ręcznego fallbacku.",
      ],
    ],
  },
  en: {
    title: (name, topic) => `${topic}: ${name} integration with MediaDock`,
    lead: (name, topic) =>
      `Connect ${name} to MediaDock and use ${topic.toLowerCase()} in a controlled live production environment. Keep the partner tool for its specialist role while planning, transport, outputs, monitoring, and team operations stay in one workflow.`,
    workflowTitle: "The integration in a production workflow",
    workflowOne: (name, summary) =>
      `${summary} In practice, ${name} remains the specialist system while MediaDock adds project, event, crew, and stream context. Operators avoid building a process from disconnected panels or copying the same data between systems.`,
    workflowTwo: (name, topic) =>
      `A ${topic.toLowerCase()} workflow can start with one source and one production, then expand to more outputs, recordings, graphics, communication, and roles. This staged model reduces rollout risk while leaving room to automate work around ${name}.`,
    technicalTitle: "Data, signal, and permission architecture",
    technicalOne: (name) =>
      `Before launch, document inputs, production identifiers, data formats, transport protocol, required permissions, and the owner of each failure. The ${name} and MediaDock contract should state which system is authoritative, when synchronisation happens, and what occurs after a lost connection.`,
    technicalTwo: (name) =>
      `A well-designed workflow separates production from distribution. ${name} can provide a signal, data, or operator action while MediaDock manages production state, outputs, archive, and team access. This improves auditability, handovers, and scale without replacing the core tool.`,
    operationsTitle: "Monitoring, fallback, and scale",
    operationsOne: (name) =>
      `Tests should cover a normal transmission, partial failure, device restart, reconnect, and a handover to another operator. For ${name}, decide in advance whether a partner failure stops the program or activates a prepared backup output.`,
    operationsTwo: (name) =>
      `After rollout, the team should see ingest, outputs, data, and tasks without opening multiple disconnected tools. MediaDock connects this information with schedules, Run of Show, prompter, intercom, graphics, and recording so the process remains repeatable across more events.`,
    steps: (name, topic) => [
      `Define the ${name} integration goal and choose one representative ${topic.toLowerCase()} scenario.`,
      "Agree on the source of truth, production identifiers, data format, and required permissions.",
      "Configure the MediaDock input, transport, and outputs for the network and delivery conditions.",
      "Add graphics, prompter, intercom, Run of Show, or recording links where the workflow needs them.",
      "Test reconnects, partial failure, backup behaviour, and an operator handover.",
      `Document the finished process and monitor the first productions using ${name}.`,
    ],
    faq: (name) => [
      [
        `What does the ${name} integration provide?`,
        `It connects ${name}'s specialist capabilities with production context, transport, outputs, and MediaDock monitoring.`,
      ],
      [
        "Can it be deployed in stages?",
        "Yes. Start with one production and one flow, then add roles, outputs, automation, and teams.",
      ],
      [
        "What should be agreed before launch?",
        "Data scope, permissions, source of truth, failure behaviour, monitoring, and a manual fallback procedure.",
      ],
    ],
  },
  de: {
    title: (name, topic) => `${topic}: ${name}-Integration mit MediaDock`,
    lead: (name, topic) =>
      `Verbinden Sie ${name} mit MediaDock und nutzen Sie ${topic.toLowerCase()} in einer kontrollierten Live-Produktion. Das Partner-Tool bleibt für seine Spezialfunktion zuständig, während Planung, Transport, Ausgänge, Monitoring und Teamarbeit in einem Workflow zusammenlaufen.`,
    workflowTitle: "Die Integration im Produktionsworkflow",
    workflowOne: (name, summary) =>
      `${summary} ${name} bleibt in der Praxis das Spezialwerkzeug, während MediaDock Projekt-, Event-, Crew- und Stream-Kontext ergänzt. Operatoren müssen keine Abläufe aus getrennten Panels zusammensetzen oder Daten zwischen Systemen kopieren.`,
    workflowTwo: (name, topic) =>
      `Ein Workflow für ${topic.toLowerCase()} kann mit einer Quelle und einer Produktion starten und später um Ausgänge, Aufnahmen, Grafiken, Kommunikation und Rollen wachsen. Dieser stufenweise Ansatz reduziert das Einführungsrisiko und schafft Raum für Automatisierung rund um ${name}.`,
    technicalTitle: "Architektur für Daten, Signal und Berechtigungen",
    technicalOne: (name) =>
      `Dokumentieren Sie vor dem Start Eingänge, Produktions-IDs, Datenformate, Transportprotokoll, Berechtigungen und die Verantwortung für Fehler. Der Vertrag zwischen ${name} und MediaDock muss festlegen, welches System führend ist, wann synchronisiert wird und was nach einem Verbindungsverlust geschieht.`,
    technicalTwo: (name) =>
      `Ein guter Workflow trennt Produktion und Distribution. ${name} kann Signal, Daten oder Operator-Aktionen liefern, während MediaDock Produktionsstatus, Ausgänge, Archiv und Teamzugriff verwaltet. Das erleichtert Übergaben, Audits und die Skalierung ohne Austausch des Kernwerkzeugs.`,
    operationsTitle: "Monitoring, Fallback und Skalierung",
    operationsOne: (name) =>
      `Tests sollten eine normale Übertragung, Teilausfall, Gerätestart, Reconnect und die Übergabe an einen anderen Operator abdecken. Für ${name} sollte vorab klar sein, ob ein Partnerfehler das Programm stoppt oder einen vorbereiteten Backup-Ausgang aktiviert.`,
    operationsTwo: (name) =>
      `Nach dem Rollout sieht das Team Ingest, Ausgänge, Daten und Aufgaben ohne mehrere getrennte Tools. MediaDock verbindet diese Informationen mit Zeitplan, Run of Show, Prompter, Intercom, Grafik und Aufnahme für wiederholbare Produktionen.`,
    steps: (name, topic) => [
      `Definieren Sie das Ziel der ${name}-Integration und ein repräsentatives ${topic.toLowerCase()}-Szenario.`,
      "Legen Sie führendes System, Produktions-IDs, Datenformat und Berechtigungen fest.",
      "Konfigurieren Sie MediaDock-Eingang, Transport und Ausgänge für Netzwerk und Ausspielung.",
      "Ergänzen Sie bei Bedarf Links zu Grafik, Prompter, Intercom, Run of Show oder Aufnahme.",
      "Testen Sie Reconnect, Teilausfall, Backup und die Übergabe an einen anderen Operator.",
      `Dokumentieren Sie den Ablauf und überwachen Sie die ersten Produktionen mit ${name}.`,
    ],
    faq: (name) => [
      [
        `Was bringt die ${name}-Integration?`,
        `Sie verbindet die Spezialfunktionen von ${name} mit Produktionskontext, Transport, Ausgängen und MediaDock-Monitoring.`,
      ],
      [
        "Kann die Einführung schrittweise erfolgen?",
        "Ja. Beginnen Sie mit einer Produktion und einem Ablauf und ergänzen Sie danach Rollen, Ausgänge und Automatisierung.",
      ],
      [
        "Was muss vor dem Start geklärt werden?",
        "Datenumfang, Berechtigungen, führendes System, Fehlerverhalten, Monitoring und ein manueller Fallback.",
      ],
    ],
  },
  es: {
    title: (name, topic) => `${topic}: integración de ${name} con MediaDock`,
    lead: (name, topic) =>
      `Conecta ${name} con MediaDock y utiliza ${topic.toLowerCase()} en un entorno controlado de producción en directo. La herramienta del partner mantiene su función especializada, mientras la planificación, el transporte, las salidas, la supervisión y el equipo trabajan en un solo flujo.`,
    workflowTitle: "La integración dentro del flujo de producción",
    workflowOne: (name, summary) =>
      `${summary} ${name} sigue siendo la herramienta especializada, mientras MediaDock añade el contexto del proyecto, evento, equipo y stream. El operador evita unir paneles desconectados o copiar los mismos datos entre sistemas.`,
    workflowTwo: (name, topic) =>
      `El flujo de ${topic.toLowerCase()} puede empezar con una fuente y una producción y crecer con más salidas, grabaciones, gráficos, comunicación y roles. Este enfoque gradual reduce el riesgo y deja espacio para automatizar el trabajo alrededor de ${name}.`,
    technicalTitle: "Arquitectura de datos, señal y permisos",
    technicalOne: (name) =>
      `Antes de empezar, documenta entradas, identificadores de producción, formatos de datos, protocolo de transporte, permisos y responsables de cada fallo. El contrato entre ${name} y MediaDock debe indicar qué sistema es la fuente de verdad, cuándo se sincroniza y qué ocurre al perder la conexión.`,
    technicalTwo: (name) =>
      `Un flujo bien diseñado separa producción y distribución. ${name} puede aportar señal, datos o acciones del operador, mientras MediaDock gestiona el estado, las salidas, el archivo y el acceso del equipo. Esto facilita las auditorías, los cambios de operador y el crecimiento.`,
    operationsTitle: "Supervisión, fallback y escalabilidad",
    operationsOne: (name) =>
      `Las pruebas deben cubrir una transmisión normal, un fallo parcial, el reinicio del equipo, la reconexión y el relevo de operador. Para ${name}, define si un fallo del partner detiene el programa o activa una salida de respaldo preparada.`,
    operationsTwo: (name) =>
      `Después del despliegue, el equipo debe ver ingest, salidas, datos y tareas sin abrir varias herramientas. MediaDock conecta esta información con agenda, Run of Show, prompter, intercom, gráficos y grabación para repetir el proceso en más eventos.`,
    steps: (name, topic) => [
      `Define el objetivo de la integración ${name} y un escenario representativo de ${topic.toLowerCase()}.`,
      "Acuerda la fuente de verdad, identificadores, formato de datos y permisos.",
      "Configura entrada, transporte y salidas de MediaDock según la red y la distribución.",
      "Añade enlaces de gráficos, prompter, intercom, Run of Show o grabación cuando hagan falta.",
      "Prueba reconexión, fallos parciales, backup y relevo de operador.",
      `Documenta el proceso y supervisa las primeras producciones con ${name}.`,
    ],
    faq: (name) => [
      [
        `¿Qué aporta la integración de ${name}?`,
        `Conecta las funciones especializadas de ${name} con el contexto, transporte, salidas y supervisión de MediaDock.`,
      ],
      [
        "¿Se puede desplegar por fases?",
        "Sí. Empieza con una producción y un flujo, y añade después roles, salidas y automatización.",
      ],
      [
        "¿Qué hay que acordar antes de empezar?",
        "Alcance de datos, permisos, fuente de verdad, comportamiento ante fallos, supervisión y fallback manual.",
      ],
    ],
  },
  fr: {
    title: (name, topic) => `${topic} : intégration de ${name} avec MediaDock`,
    lead: (name, topic) =>
      `Connectez ${name} à MediaDock et utilisez ${topic.toLowerCase()} dans un environnement de production live maîtrisé. L’outil partenaire conserve sa fonction spécialisée, tandis que planification, transport, sorties, supervision et équipe sont réunis dans un même workflow.`,
    workflowTitle: "L’intégration dans le workflow de production",
    workflowOne: (name, summary) =>
      `${summary} ${name} reste l’outil spécialisé, tandis que MediaDock ajoute le contexte du projet, de l’événement, de l’équipe et du flux. L’opérateur évite de composer un processus à partir de panneaux séparés ou de recopier les mêmes données.`,
    workflowTwo: (name, topic) =>
      `Le workflow ${topic.toLowerCase()} peut commencer avec une source et une production, puis intégrer sorties, enregistrements, graphismes, communication et rôles. Cette approche progressive limite le risque tout en laissant de la place à l’automatisation autour de ${name}.`,
    technicalTitle: "Architecture des données, du signal et des droits",
    technicalOne: (name) =>
      `Avant le lancement, documentez les entrées, identifiants de production, formats, protocole de transport, droits requis et responsable de chaque incident. Le contrat entre ${name} et MediaDock doit préciser la source de vérité, le moment de synchronisation et le comportement après une perte de connexion.`,
    technicalTwo: (name) =>
      `Un workflow bien conçu sépare production et distribution. ${name} peut fournir un signal, des données ou une action opérateur, tandis que MediaDock gère l’état, les sorties, l’archive et les accès de l’équipe. Cela facilite audit, passation et montée en charge.`,
    operationsTitle: "Supervision, fallback et montée en charge",
    operationsOne: (name) =>
      `Les tests doivent couvrir une transmission normale, une panne partielle, un redémarrage, une reconnexion et une passation à un autre opérateur. Pour ${name}, décidez si une panne partenaire arrête le programme ou active une sortie de secours préparée.`,
    operationsTwo: (name) =>
      `Après le déploiement, l’équipe doit voir ingest, sorties, données et tâches sans ouvrir plusieurs outils. MediaDock relie ces informations au planning, Run of Show, prompteur, intercom, graphismes et enregistrement pour des productions répétables.`,
    steps: (name, topic) => [
      `Définissez l’objectif de l’intégration ${name} et un scénario représentatif de ${topic.toLowerCase()}.`,
      "Définissez la source de vérité, les identifiants, le format des données et les droits.",
      "Configurez entrée, transport et sorties MediaDock selon le réseau et la diffusion.",
      "Ajoutez les liens vers graphismes, prompteur, intercom, Run of Show ou enregistrement.",
      "Testez reconnexion, panne partielle, backup et passation opérateur.",
      `Documentez le processus et surveillez les premières productions avec ${name}.`,
    ],
    faq: (name) => [
      [
        `Que fournit l’intégration ${name} ?`,
        `Elle relie les fonctions spécialisées de ${name} au contexte, transport, sorties et monitoring MediaDock.`,
      ],
      [
        "Peut-elle être déployée par étapes ?",
        "Oui. Commencez par une production et un flux, puis ajoutez rôles, sorties et automatisations.",
      ],
      [
        "Que faut-il définir avant le lancement ?",
        "Périmètre des données, droits, source de vérité, gestion des incidents, monitoring et fallback manuel.",
      ],
    ],
  },
  it: {
    title: (name, topic) => `${topic}: integrazione ${name} con MediaDock`,
    lead: (name, topic) =>
      `Collega ${name} a MediaDock e usa ${topic.toLowerCase()} in un ambiente controllato per la produzione live. Lo strumento partner mantiene il proprio ruolo specialistico, mentre pianificazione, trasporto, uscite, monitoraggio e team lavorano nello stesso workflow.`,
    workflowTitle: "L’integrazione nel workflow di produzione",
    workflowOne: (name, summary) =>
      `${summary} ${name} resta lo strumento specialistico, mentre MediaDock aggiunge il contesto di progetto, evento, team e stream. L’operatore evita pannelli scollegati e la copia manuale degli stessi dati.`,
    workflowTwo: (name, topic) =>
      `Il workflow ${topic.toLowerCase()} può iniziare con una sorgente e una produzione e crescere con uscite, registrazioni, grafiche, comunicazione e ruoli. Questo approccio progressivo riduce il rischio e lascia spazio all’automazione intorno a ${name}.`,
    technicalTitle: "Architettura di dati, segnale e permessi",
    technicalOne: (name) =>
      `Prima del lancio documenta ingressi, identificativi della produzione, formati, protocollo di trasporto, permessi e responsabili degli errori. Il contratto tra ${name} e MediaDock deve indicare la fonte autorevole, la sincronizzazione e il comportamento dopo una perdita di connessione.`,
    technicalTwo: (name) =>
      `Un workflow ben progettato separa produzione e distribuzione. ${name} può fornire segnale, dati o azioni operative mentre MediaDock gestisce stato, uscite, archivio e accesso del team. Questo semplifica audit, passaggi di consegne e crescita.`,
    operationsTitle: "Monitoraggio, fallback e scalabilità",
    operationsOne: (name) =>
      `I test devono coprire trasmissione normale, guasto parziale, riavvio, riconnessione e passaggio a un altro operatore. Per ${name}, stabilisci se un guasto del partner ferma il programma o attiva un’uscita di backup preparata.`,
    operationsTwo: (name) =>
      `Dopo il rilascio il team deve vedere ingest, uscite, dati e attività senza aprire strumenti separati. MediaDock collega queste informazioni a calendario, Run of Show, prompter, intercom, grafiche e registrazione.`,
    steps: (name, topic) => [
      `Definisci l’obiettivo dell’integrazione ${name} e uno scenario rappresentativo di ${topic.toLowerCase()}.`,
      "Stabilisci fonte autorevole, identificativi, formato dati e permessi.",
      "Configura ingresso, trasporto e uscite MediaDock in base a rete e distribuzione.",
      "Aggiungi collegamenti a grafiche, prompter, intercom, Run of Show o registrazione.",
      "Testa riconnessione, guasto parziale, backup e passaggio operatore.",
      `Documenta il processo e monitora le prime produzioni con ${name}.`,
    ],
    faq: (name) => [
      [
        `Cosa offre l’integrazione ${name}?`,
        `Collega le funzioni specialistiche di ${name} al contesto di produzione, trasporto, uscite e monitoraggio MediaDock.`,
      ],
      [
        "È possibile procedere per fasi?",
        "Sì. Inizia con una produzione e un flusso, poi aggiungi ruoli, uscite e automazioni.",
      ],
      [
        "Cosa definire prima del lancio?",
        "Ambito dati, permessi, fonte autorevole, gestione errori, monitoraggio e fallback manuale.",
      ],
    ],
  },
  sk: {
    title: (name, topic) => `${topic}: integrácia ${name} s MediaDock`,
    lead: (name, topic) =>
      `Prepojte ${name} s MediaDock a používajte ${topic.toLowerCase()} v kontrolovanom prostredí živej produkcie. Partnerský nástroj si ponechá svoju špecializovanú funkciu, zatiaľ čo plánovanie, prenos, výstupy, monitoring a tím zostanú v jednom workflow.`,
    workflowTitle: "Integrácia v produkčnom workflow",
    workflowOne: (name, summary) =>
      `${summary} ${name} zostáva špecializovaným nástrojom, zatiaľ čo MediaDock pridáva kontext projektu, udalosti, tímu a streamu. Operátor nemusí skladať proces z oddelených panelov ani kopírovať rovnaké údaje.`,
    workflowTwo: (name, topic) =>
      `Workflow pre ${topic.toLowerCase()} môže začať jedným zdrojom a produkciou a neskôr pridať výstupy, nahrávky, grafiku, komunikáciu a roly. Postupné nasadenie znižuje riziko a ponecháva priestor na automatizáciu okolo ${name}.`,
    technicalTitle: "Architektúra dát, signálu a oprávnení",
    technicalOne: (name) =>
      `Pred spustením opíšte vstupy, identifikátory produkcie, formáty dát, prenosový protokol, oprávnenia a vlastníka každej chyby. Kontrakt medzi ${name} a MediaDock musí určiť zdroj pravdy, synchronizáciu a správanie po strate spojenia.`,
    technicalTwo: (name) =>
      `Dobre navrhnutý workflow oddeľuje produkciu od distribúcie. ${name} môže dodať signál, dáta alebo akciu operátora, zatiaľ čo MediaDock riadi stav produkcie, výstupy, archív a prístup tímu. To uľahčuje odovzdanie aj škálovanie.`,
    operationsTitle: "Monitoring, fallback a škálovanie",
    operationsOne: (name) =>
      `Testy majú pokrývať bežný prenos, čiastočný výpadok, reštart zariadenia, reconnect a odovzdanie inému operátorovi. Pri ${name} vopred určte, či chyba partnera zastaví program alebo aktivuje pripravený záložný výstup.`,
    operationsTwo: (name) =>
      `Po nasadení musí tím vidieť ingest, výstupy, dáta a úlohy bez viacerých oddelených nástrojov. MediaDock spája tieto informácie s plánom, Run of Show, prompterom, intercomom, grafikou a nahrávaním.`,
    steps: (name, topic) => [
      `Definujte cieľ integrácie ${name} a reprezentatívny scenár ${topic.toLowerCase()}.`,
      "Určte zdroj pravdy, identifikátory produkcie, formát dát a oprávnenia.",
      "Nastavte vstup, prenos a výstupy MediaDock podľa siete a distribúcie.",
      "Pridajte odkazy na grafiku, prompter, intercom, Run of Show alebo nahrávanie.",
      "Otestujte reconnect, čiastočný výpadok, zálohu a odovzdanie operátorovi.",
      `Zdokumentujte proces a sledujte prvé produkcie s ${name}.`,
    ],
    faq: (name) => [
      [
        `Čo prináša integrácia ${name}?`,
        `Spája špecializované funkcie ${name} s kontextom produkcie, prenosom, výstupmi a monitoringom MediaDock.`,
      ],
      [
        "Dá sa nasadiť postupne?",
        "Áno. Začnite jednou produkciou a tokom, potom pridajte roly, výstupy a automatizáciu.",
      ],
      [
        "Čo treba dohodnúť pred štartom?",
        "Rozsah dát, oprávnenia, zdroj pravdy, správanie pri chybe, monitoring a manuálny fallback.",
      ],
    ],
  },
  uk: {
    title: (name, topic) => `${topic}: інтеграція ${name} з MediaDock`,
    lead: (name, topic) =>
      `Підключіть ${name} до MediaDock і використовуйте ${topic.toLowerCase()} у контрольованому середовищі прямого виробництва. Інструмент партнера зберігає спеціалізовану роль, а планування, транспорт, виходи, моніторинг і команда працюють в одному workflow.`,
    workflowTitle: "Інтеграція у виробничий workflow",
    workflowOne: (name, summary) =>
      `${summary} ${name} залишається спеціалізованим інструментом, а MediaDock додає контекст проєкту, події, команди та потоку. Оператору не потрібно поєднувати розрізнені панелі або копіювати ті самі дані між системами.`,
    workflowTwo: (name, topic) =>
      `Workflow для ${topic.toLowerCase()} може початися з одного джерела та виробництва, а потім розширюватися виходами, записами, графікою, комунікацією та ролями. Поетапне впровадження зменшує ризик і залишає простір для автоматизації навколо ${name}.`,
    technicalTitle: "Архітектура даних, сигналу та дозволів",
    technicalOne: (name) =>
      `До запуску опишіть входи, ідентифікатори виробництва, формати даних, протокол транспорту, дозволи та відповідального за кожну помилку. Контракт між ${name} і MediaDock має визначати джерело правди, момент синхронізації та поведінку після втрати з’єднання.`,
    technicalTwo: (name) =>
      `Добре спроєктований workflow розділяє виробництво і дистрибуцію. ${name} може надавати сигнал, дані або дію оператора, а MediaDock керує станом виробництва, виходами, архівом і доступом команди. Це спрощує аудит, передачу зміни та масштабування.`,
    operationsTitle: "Моніторинг, fallback і масштабування",
    operationsOne: (name) =>
      `Тести мають охоплювати нормальну трансляцію, частковий збій, перезапуск пристрою, повторне підключення та передачу іншому оператору. Для ${name} заздалегідь визначте, чи помилка партнера зупиняє програму, чи запускає підготовлений резервний вихід.`,
    operationsTwo: (name) =>
      `Після запуску команда має бачити ingest, виходи, дані та завдання без відкриття кількох розрізнених інструментів. MediaDock поєднує це з розкладом, Run of Show, промптером, інтеркомом, графікою та записом.`,
    steps: (name, topic) => [
      `Визначте мету інтеграції ${name} і репрезентативний сценарій ${topic.toLowerCase()}.`,
      "Узгодьте джерело правди, ідентифікатори виробництва, формат даних і дозволи.",
      "Налаштуйте вхід, транспорт і виходи MediaDock відповідно до мережі та дистрибуції.",
      "Додайте посилання на графіку, промптер, інтерком, Run of Show або запис.",
      "Перевірте повторне підключення, частковий збій, резерв і передачу керування оператору.",
      `Задокументуйте процес і моніторте перші виробництва з ${name}.`,
    ],
    faq: (name) => [
      [
        `Що дає інтеграція ${name}?`,
        `Вона поєднує спеціалізовані можливості ${name} з контекстом виробництва, транспортом, виходами та моніторингом MediaDock.`,
      ],
      [
        "Чи можна впроваджувати її поетапно?",
        "Так. Почніть з одного виробництва і потоку, а потім додавайте ролі, виходи та автоматизацію.",
      ],
      [
        "Що узгодити до запуску?",
        "Обсяг даних, дозволи, джерело правди, поведінку при збоях, моніторинг і ручний fallback.",
      ],
    ],
  },
};

const CLIENT_FRAME = {
  pl: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Dzięki połączeniu z MediaDock możesz korzystać z tej funkcji w kontekście swoich projektów, zespołu i codziennej pracy, bez przenoszenia się między przypadkowymi narzędziami.`,
    benefitsTitle: "Najważniejsze korzyści",
    howTitle: "Jak działa to dla klienta",
    howOne: (name) =>
      `${name} zachowuje swoją specjalistyczną rolę, a MediaDock dodaje do niej kontekst Twojej produkcji, wydarzeń, użytkowników i zasobów. Korzystasz z partnera tam, gdzie jest najlepszy, a wynik trafia do jednego środowiska pracy.`,
    howTwo: () =>
      "Dzięki temu możesz rozpocząć działanie w znanym workflow i stopniowo wykorzystywać kolejne możliwości MediaDock: planowanie, transmisję, grafikę, komunikację, nagrania lub obsługę klienta.",
    valueTitle: "W praktyce",
    valueOne: (name) =>
      `Integracja ${name} pomaga skrócić liczbę ręcznych czynności i szybciej przejść od potrzeby do rezultatu. Zespół widzi, co zostało uruchomione, kto za to odpowiada i jaki jest kolejny krok.`,
    valueTwo: () =>
      "To rozwiązanie dla klientów, którzy chcą zachować swoje sprawdzone narzędzia, ale jednocześnie mieć jedno miejsce do organizacji pracy i obsługi produkcji.",
    faq: (name, summary) => [
      [`Co daje integracja ${name}?`, summary],
      [
        "Czy muszę zmieniać cały obecny workflow?",
        "Nie. Integracja uzupełnia używane narzędzia i pozwala korzystać z MediaDock etapami, zgodnie z potrzebami zespołu.",
      ],
      [
        "Dla kogo jest to rozwiązanie?",
        "Dla klientów, którzy chcą połączyć specjalistyczną usługę partnera z organizacją produkcji i pracą zespołu w MediaDock.",
      ],
    ],
  },
  en: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Connecting it with MediaDock lets you use that capability in the context of your projects, team, and daily work without jumping between disconnected tools.`,
    benefitsTitle: "Key customer benefits",
    howTitle: "How it works for the customer",
    howOne: (name) =>
      `${name} keeps its specialist role while MediaDock adds the context of your productions, events, users, and resources. You use the partner where it is strongest and keep the result in one working environment.`,
    howTwo: () =>
      "You can keep the workflow your team already knows and gradually use more MediaDock capabilities for planning, streaming, graphics, communication, recording, or customer operations.",
    valueTitle: "In practice",
    valueOne: (name) =>
      `The ${name} integration reduces manual steps and helps the team move from a need to a result faster. Everyone can see what is active, who owns it, and what happens next.`,
    valueTwo: () =>
      "It is designed for customers who want to keep proven specialist tools while gaining one place to organise work and run productions.",
    faq: (name, summary) => [
      [`What does the ${name} integration provide?`, summary],
      [
        "Do I need to replace my current workflow?",
        "No. The integration extends the tools you already use and lets you adopt MediaDock in stages.",
      ],
      [
        "Who is it for?",
        "Customers who want to connect a specialist partner service with production organisation and team work in MediaDock.",
      ],
    ],
  },
  de: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Mit MediaDock nutzen Sie diese Funktion im Kontext Ihrer Projekte, Ihres Teams und Ihrer täglichen Arbeit, ohne zwischen getrennten Tools zu wechseln.`,
    benefitsTitle: "Ihre wichtigsten Vorteile",
    howTitle: "So funktioniert es für Kunden",
    howOne: (name) =>
      `${name} behält seine Spezialfunktion, während MediaDock den Kontext von Produktionen, Events, Benutzern und Ressourcen ergänzt. Sie nutzen den Partner dort, wo er stark ist, und arbeiten mit dem Ergebnis an einem Ort.`,
    howTwo: () =>
      "Ihr Team kann den bekannten Workflow beibehalten und schrittweise weitere MediaDock-Funktionen für Planung, Streaming, Grafik, Kommunikation, Aufnahmen oder Kundenarbeit nutzen.",
    valueTitle: "In der Praxis",
    valueOne: (name) =>
      `Die ${name}-Integration reduziert manuelle Schritte und bringt das Team schneller vom Bedarf zum Ergebnis. Jeder sieht, was aktiv ist, wer dafür zuständig ist und was als Nächstes passiert.`,
    valueTwo: () =>
      "Die Lösung eignet sich für Kunden, die bewährte Spezialtools behalten und gleichzeitig einen Ort für Organisation und Produktion gewinnen möchten.",
    faq: (name, summary) => [
      [`Was bietet die ${name}-Integration?`, summary],
      [
        "Muss der bestehende Workflow ersetzt werden?",
        "Nein. Die Integration ergänzt vorhandene Tools und ermöglicht eine schrittweise Nutzung von MediaDock.",
      ],
      [
        "Für wen ist die Lösung geeignet?",
        "Für Kunden, die einen spezialisierten Partnerdienst mit Produktionsorganisation und Teamarbeit in MediaDock verbinden möchten.",
      ],
    ],
  },
  es: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Al conectarlo con MediaDock puedes usar esta capacidad dentro del contexto de tus proyectos, tu equipo y tu trabajo diario, sin saltar entre herramientas desconectadas.`,
    benefitsTitle: "Principales beneficios para el cliente",
    howTitle: "Cómo funciona para el cliente",
    howOne: (name) =>
      `${name} conserva su función especializada y MediaDock añade el contexto de tus producciones, eventos, usuarios y recursos. Usas el partner donde aporta más valor y mantienes el resultado en un único entorno de trabajo.`,
    howTwo: () =>
      "Puedes mantener el flujo que tu equipo ya conoce y aprovechar poco a poco más funciones de MediaDock para planificación, streaming, gráficos, comunicación, grabación o atención al cliente.",
    valueTitle: "En la práctica",
    valueOne: (name) =>
      `La integración con ${name} reduce tareas manuales y ayuda al equipo a pasar antes de la necesidad al resultado. Todos pueden ver qué está activo, quién se encarga y cuál es el siguiente paso.`,
    valueTwo: () =>
      "Es una solución para clientes que quieren conservar herramientas especializadas probadas y obtener un único lugar para organizar el trabajo y las producciones.",
    faq: (name, summary) => [
      [`¿Qué ofrece la integración de ${name}?`, summary],
      [
        "¿Tengo que cambiar todo mi flujo actual?",
        "No. La integración amplía las herramientas que ya usas y permite adoptar MediaDock por fases.",
      ],
      [
        "¿Para quién es?",
        "Para clientes que quieren conectar un servicio especializado con la organización de producciones y el trabajo del equipo en MediaDock.",
      ],
    ],
  },
  fr: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Avec MediaDock, vous utilisez cette capacité dans le contexte de vos projets, de votre équipe et de votre travail quotidien, sans passer entre des outils séparés.`,
    benefitsTitle: "Vos principaux bénéfices",
    howTitle: "Comment cela fonctionne pour le client",
    howOne: (name) =>
      `${name} conserve son rôle spécialisé tandis que MediaDock ajoute le contexte de vos productions, événements, utilisateurs et ressources. Vous utilisez le partenaire là où il est le plus utile et gardez le résultat dans un seul environnement.`,
    howTwo: () =>
      "Votre équipe peut conserver ses habitudes et utiliser progressivement les fonctions MediaDock pour la planification, la diffusion, les graphismes, la communication, l’enregistrement ou la relation client.",
    valueTitle: "En pratique",
    valueOne: (name) =>
      `L’intégration ${name} réduit les tâches manuelles et aide l’équipe à passer plus vite du besoin au résultat. Chacun voit ce qui est actif, le responsable et la prochaine étape.`,
    valueTwo: () =>
      "La solution s’adresse aux clients qui veulent garder leurs outils spécialisés tout en disposant d’un espace unique pour organiser le travail et les productions.",
    faq: (name, summary) => [
      [`Que fournit l’intégration ${name} ?`, summary],
      [
        "Faut-il remplacer le workflow actuel ?",
        "Non. L’intégration complète les outils existants et permet d’adopter MediaDock progressivement.",
      ],
      [
        "À qui s’adresse-t-elle ?",
        "Aux clients qui veulent relier un service spécialisé à l’organisation de la production et au travail d’équipe dans MediaDock.",
      ],
    ],
  },
  it: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Con MediaDock puoi usare questa capacità nel contesto dei tuoi progetti, del team e del lavoro quotidiano, senza passare tra strumenti scollegati.`,
    benefitsTitle: "I principali vantaggi per il cliente",
    howTitle: "Come funziona per il cliente",
    howOne: (name) =>
      `${name} mantiene il proprio ruolo specialistico mentre MediaDock aggiunge il contesto di produzioni, eventi, utenti e risorse. Usi il partner dove offre più valore e mantieni il risultato in un unico ambiente.`,
    howTwo: () =>
      "Il team può mantenere il workflow che già conosce e usare gradualmente le funzioni MediaDock per pianificazione, streaming, grafiche, comunicazione, registrazione o gestione clienti.",
    valueTitle: "In pratica",
    valueOne: (name) =>
      `L’integrazione con ${name} riduce le attività manuali e aiuta il team a passare più velocemente dal bisogno al risultato. Tutti vedono cosa è attivo, chi lo gestisce e qual è il passo successivo.`,
    valueTwo: () =>
      "È pensata per clienti che vogliono mantenere strumenti specialistici collaudati e avere un unico spazio per organizzare il lavoro e le produzioni.",
    faq: (name, summary) => [
      [`Cosa offre l’integrazione ${name}?`, summary],
      [
        "Devo cambiare tutto il workflow attuale?",
        "No. L’integrazione estende gli strumenti esistenti e permette di adottare MediaDock gradualmente.",
      ],
      [
        "Per chi è pensata?",
        "Per clienti che vogliono collegare un servizio specialistico all’organizzazione della produzione e al lavoro del team in MediaDock.",
      ],
    ],
  },
  sk: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Vďaka MediaDock môžete túto funkciu používať v kontexte svojich projektov, tímu a každodennej práce bez prepínania medzi nesúvisiacimi nástrojmi.`,
    benefitsTitle: "Hlavné výhody pre zákazníka",
    howTitle: "Ako to funguje pre zákazníka",
    howOne: (name) =>
      `${name} si zachová svoju špecializovanú úlohu a MediaDock pridá kontext produkcií, udalostí, používateľov a zdrojov. Partnera používate tam, kde je najsilnejší, a výsledok zostáva v jednom pracovnom prostredí.`,
    howTwo: () =>
      "Tím môže pokračovať v známom workflow a postupne využívať ďalšie funkcie MediaDock pre plánovanie, streamovanie, grafiku, komunikáciu, nahrávanie alebo prácu so zákazníkmi.",
    valueTitle: "V praxi",
    valueOne: (name) =>
      `Integrácia ${name} znižuje počet manuálnych krokov a pomáha tímu rýchlejšie prejsť od potreby k výsledku. Každý vidí, čo je aktívne, kto to spravuje a čo nasleduje.`,
    valueTwo: () =>
      "Je určená pre zákazníkov, ktorí si chcú ponechať overené špecializované nástroje a zároveň získať jedno miesto na organizáciu práce a produkcií.",
    faq: (name, summary) => [
      [`Čo prináša integrácia ${name}?`, summary],
      [
        "Musím meniť celý súčasný workflow?",
        "Nie. Integrácia rozšíri nástroje, ktoré už používate, a MediaDock môžete zavádzať postupne.",
      ],
      [
        "Pre koho je riešenie určené?",
        "Pre zákazníkov, ktorí chcú spojiť špecializovanú službu s organizáciou produkcie a tímovou prácou v MediaDock.",
      ],
    ],
  },
  uk: {
    title: (name, topic) =>
      topic === name ? `${name} + MediaDock` : `${name} — ${topic}`,
    lead: (name, summary) =>
      `${summary} Завдяки MediaDock ви використовуєте цю можливість у контексті своїх проєктів, команди та щоденної роботи без переходів між розрізненими інструментами.`,
    benefitsTitle: "Головні переваги для клієнта",
    howTitle: "Як це працює для клієнта",
    howOne: (name) =>
      `${name} зберігає свою спеціалізовану роль, а MediaDock додає контекст виробництв, подій, користувачів і ресурсів. Ви використовуєте партнера там, де він найсильніший, а результат залишається в одному робочому середовищі.`,
    howTwo: () =>
      "Команда може залишити знайомий workflow і поступово використовувати можливості MediaDock для планування, трансляції, графіки, комунікації, запису або роботи з клієнтами.",
    valueTitle: "На практиці",
    valueOne: (name) =>
      `Інтеграція ${name} зменшує кількість ручних дій і допомагає швидше перейти від потреби до результату. Команда бачить, що працює, хто відповідає і який наступний крок.`,
    valueTwo: () =>
      "Це рішення для клієнтів, які хочуть зберегти перевірені спеціалізовані інструменти й отримати одне місце для організації роботи та виробництв.",
    faq: (name, summary) => [
      [`Що дає інтеграція ${name}?`, summary],
      [
        "Чи потрібно змінювати весь поточний workflow?",
        "Ні. Інтеграція доповнює наявні інструменти, а MediaDock можна впроваджувати поетапно.",
      ],
      [
        "Для кого це рішення?",
        "Для клієнтів, які хочуть поєднати спеціалізований сервіс з організацією виробництва та роботою команди в MediaDock.",
      ],
    ],
  },
};

const RESOURCE_PATHS = {
  services: "/services",
  streams: "/transmisje-live",
  srt: "/serwer-srt",
  recording: "/nagrywanie-transmisji-w-chmurze",
  graphics: "/grafika-ekranowa",
  remote: "/produkcja-zdalna",
  rundown: "/scenariusz-transmisji",
  intercom: "/interkom-online",
  register: "/register",
  contact: "/contact",
  compare: "/compare",
};

const RESOURCE_LABELS = {
  pl: {
    services: "Wszystkie usługi",
    streams: "Transmisje live",
    srt: "Serwer SRT",
    recording: "Nagrywanie w chmurze",
    graphics: "Grafika ekranowa",
    remote: "Produkcja zdalna",
    rundown: "Run of Show",
    intercom: "Interkom online",
    register: "Załóż konto",
    contact: "Kontakt",
    compare: "Porównaj usługi",
  },
  en: {
    services: "All services",
    streams: "Live streaming",
    srt: "SRT server",
    recording: "Cloud recording",
    graphics: "On-screen graphics",
    remote: "Remote production",
    rundown: "Run of Show",
    intercom: "Online intercom",
    register: "Create an account",
    contact: "Contact",
    compare: "Compare services",
  },
  de: {
    services: "Alle Services",
    streams: "Live-Streaming",
    srt: "SRT-Server",
    recording: "Cloud-Aufzeichnung",
    graphics: "On-Screen-Grafik",
    remote: "Remote-Produktion",
    rundown: "Run of Show",
    intercom: "Online-Intercom",
    register: "Konto erstellen",
    contact: "Kontakt",
    compare: "Services vergleichen",
  },
  es: {
    services: "Todos los servicios",
    streams: "Streaming en directo",
    srt: "Servidor SRT",
    recording: "Grabación en la nube",
    graphics: "Gráficos en pantalla",
    remote: "Producción remota",
    rundown: "Run of Show",
    intercom: "Intercom online",
    register: "Crear una cuenta",
    contact: "Contacto",
    compare: "Comparar servicios",
  },
  fr: {
    services: "Tous les services",
    streams: "Diffusion live",
    srt: "Serveur SRT",
    recording: "Enregistrement cloud",
    graphics: "Graphismes à l’écran",
    remote: "Production à distance",
    rundown: "Run of Show",
    intercom: "Intercom en ligne",
    register: "Créer un compte",
    contact: "Contact",
    compare: "Comparer les services",
  },
  it: {
    services: "Tutti i servizi",
    streams: "Streaming live",
    srt: "Server SRT",
    recording: "Registrazione cloud",
    graphics: "Grafiche a schermo",
    remote: "Produzione remota",
    rundown: "Run of Show",
    intercom: "Intercom online",
    register: "Crea un account",
    contact: "Contatti",
    compare: "Confronta i servizi",
  },
  sk: {
    services: "Všetky služby",
    streams: "Živé vysielanie",
    srt: "SRT server",
    recording: "Nahrávanie v cloude",
    graphics: "Grafika na obrazovke",
    remote: "Vzdialená produkcia",
    rundown: "Run of Show",
    intercom: "Online intercom",
    register: "Vytvoriť účet",
    contact: "Kontakt",
    compare: "Porovnať služby",
  },
  uk: {
    services: "Усі сервіси",
    streams: "Пряма трансляція",
    srt: "SRT-сервер",
    recording: "Хмарний запис",
    graphics: "Екранна графіка",
    remote: "Віддалене виробництво",
    rundown: "Run of Show",
    intercom: "Онлайн-інтерком",
    register: "Створити акаунт",
    contact: "Контакти",
    compare: "Порівняти сервіси",
  },
};

const RESOURCE_KEYS_BY_SLUG = {
  vmix: ["streams", "srt", "recording", "register", "contact"],
  obs: ["graphics", "streams", "srt", "services", "register"],
  blackmagic: ["streams", "graphics", "recording", "services", "contact"],
  companion: ["rundown", "intercom", "graphics", "register", "contact"],
};

function localeCode(language) {
  const code = String(language || "en")
    .toLowerCase()
    .split("-")[0];
  return LOCALE_KEYS.includes(code) ? code : "en";
}

export function getIntegrationPageLabels(language) {
  return PAGE_LABELS[localeCode(language)] || PAGE_LABELS.en;
}

export function getIntegrationResourceLinks(slug, language) {
  const code = localeCode(language);
  const labels = RESOURCE_LABELS[code] || RESOURCE_LABELS.en;
  const keys = RESOURCE_KEYS_BY_SLUG[slug] || [
    "services",
    "compare",
    "streams",
    "register",
    "contact",
  ];
  return keys.map((key) => ({
    key,
    label: labels[key],
    path: RESOURCE_PATHS[key],
  }));
}

export function getLocalizedIntegrationDetail(slug, language, item) {
  const code = localeCode(language);
  const frame = CLIENT_FRAME[code] || CLIENT_FRAME.en;
  const name = item?.name || "MediaDock integration";
  const summary =
    item?.summary || "This workflow connects a specialist tool with MediaDock.";
  const topic = TOPICS[slug]?.[code] || summary;
  const benefits = Array.isArray(item?.bullets) ? item.bullets : [];
  return {
    eyebrow: `${name} + MediaDock`,
    metaTitle: `${name} + MediaDock | ${topic}`,
    title: frame.title(name, topic),
    lead: frame.lead(name, summary),
    sections: [
      {
        title: frame.benefitsTitle,
        paragraphs: [summary, benefits.join(" ")],
      },
      {
        title: frame.howTitle,
        paragraphs: [frame.howOne(name), frame.howTwo(name)],
      },
      {
        title: frame.valueTitle,
        paragraphs: [frame.valueOne(name), frame.valueTwo(name)],
      },
    ],
    implementation: benefits,
    faq: frame.faq(name, summary),
  };
}
